// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global variables adn mixins are defined here */
::ng-deep .cdk-global-scrollblock {
  overflow: hidden;
}

::ng-deep mat-pseudo-checkbox {
  width: 0px !important;
}

::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  width: auto !important;
}

::ng-deep .mdc-list-item__primary-text {
  margin: 0px !important;
}

::ng-deep .mdc-tab__ripple {
  display: none;
}

::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background,
.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true]:enabled ~ .mdc-checkbox__background {
  background-color: #3e97ff !important;
  border-color: #3e97ff !important;
}

.toaster {
  background-color: #f4f7ff !important;
}

/* variables */
/* MIXINS */
/* mixin for border radius */
/* To create a section at the center of window */
/* To include and adjust background image */
/* to split the input */
/* box-shadow generator
    \$clr- in RGBA format
 */
/*
remove the autofilled background color
*/
/* mixin for create buttons */
/* generate margin & padding */
/* to set the table row */
/* to set the image */
/* to set the styles for first and last child div */
/* to set the font style */
.ast-table .table {
  margin-bottom: 0px;
}
.ast-table table thead th {
  background-color: #edeced;
  border: 1px solid #dee2e6;
  border-top: none !important;
}
.ast-table table td {
  background-color: #fafafa;
  color: #231f20;
  border: 0.5px solid #e2e2e1;
  font-size: 16px;
  font-weight: 500;
  font-family: "Amazon Ember Display Light";
}

/* To create a card at the center */
::ng-deep mat-pseudo-checkbox {
  display: none !important;
}

::ng-deep .mat-calendar-body-selected {
  background-color: #3e97ff !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {
  border-bottom: none !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {
  border-bottom: none !important;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  background-color: #f2f4ff !important;
}

::ng-deep .mat-form-field {
  border: none !important;
}

.dateselect mat-form-field {
  display: flex;
  height: 25px;
  width: 185px;
  font-size: 12px;
  text-align: center;
  height: 24px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin-top: 7px;
  margin-left: 8px;
}
.dateselect mat-form-field mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.dateselect mat-form-field mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.dateselect mat-form-field ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.dateselect mat-form-field mat-label {
  font-size: 12px;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle {
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle button {
  margin-left: 35px;
  width: 20px !important;
}
.dateselect mat-form-field ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

::ng-deep .mat-mdc-form-field-icon-suffix,
[dir=rtl] .mat-mdc-form-field-icon-prefix {
  width: 30px !important;
  margin-top: 10px;
}

::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {
  align-items: center;
  border-radius: 5px;
}

::ng-deep .mat-mdc-icon-button {
  --mat-icon-button-hover-state-layer-opacity: 0 !important;
}

::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {
  display: none;
}

.tab-header ::ng-deep .mat-mdc-tab-list {
  align-content: center;
}
.tab-header ::ng-deep .mat-mdc-tab-links {
  gap: 5px;
}

/** Date Picker **/
::ng-deep mat-datepicker-toggle {
  width: 0 !important;
}
::ng-deep mat-datepicker-toggle button {
  position: absolute;
  /* margin-bottom: -20px; */
  top: -23% !important;
  right: 40px;
}

.date-picker {
  height: 25px;
  min-width: 180px;
  font-size: 12px;
  text-align: center;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  margin: 7px 0;
}
.date-picker mat-form-field {
  width: 210px;
}
.date-picker ::ng-deep .mdc-text-field {
  padding-left: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  padding: 0 !important;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {
  height: 23px;
}
.date-picker ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {
  width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}
.date-picker mat-date-range-input {
  color: #959cbd !important;
  display: flex;
  justify-self: center;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  color: #959cbd !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-inner {
  letter-spacing: 0.5px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-container {
  justify-content: center;
  font-family: "Poppins";
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 10px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-content {
  border-bottom: none !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-end-wrapper {
  flex-grow: initial !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-wrapper {
  width: 70px;
}
.date-picker mat-label {
  font-size: 12px;
}
.date-picker ::ng-deep mat-datepicker-toggle button {
  width: 24px !important;
  height: 24px !important;
  padding: 0 !important;
  transform: translateX(10px);
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
  background-position: center;
}
.date-picker ::ng-deep mat-datepicker-toggle .mat-mdc-icon-button svg {
  display: none !important;
}

/** Date Picker **/
.back-button,
.close-button {
  width: 35px;
  height: 35px;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: all 0.25s;
}

.back-button {
  background-image: url('back.svg');
}
.back-button:hover {
  background-image: url('back-hover.svg');
}

.close-button {
  background-image: url('close-circle.svg');
}
.close-button:hover {
  background-image: url('close-cirlce-hover.svg');
}

* {
  font-size: 14px;
}

.firstCol {
  display: flex;
  justify-content: center;
}
.firstCol img {
  width: 100%;
  padding: 25px;
}

.date-picker {
  width: 100%;
  height: 34px;
  max-width: 300px;
}
.date-picker mat-date-range-input {
  font-size: 12px !important;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-separator {
  margin: 0;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-wrapper {
  width: 90px;
}
.date-picker mat-date-range-input ::ng-deep .mat-date-range-input-inner {
  font-size: 12px !important;
}
.date-picker ::ng-deep mat-datepicker-toggle button {
  width: 30px !important;
  height: 30px !important;
  transform: translateX(5px);
}
.date-picker mat-form-field {
  width: 100%;
}
.date-picker mat-form-field mat-label {
  font-size: 12px;
}

.secondCol {
  display: flex;
  justify-content: center;
  align-items: center;
}

.background {
  padding: 15px 20px 0;
}

::ng-deep .mat-mdc-dialog-container .mdc-dialog__container {
  height: auto;
}

::ng-deep .downloadFilter-dialog ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  overflow: auto;
  overflow-x: hidden;
  width: 100% !important;
  height: auto !important;
}

mat-select .breakPoint {
  width: 100% !important;
}

.breakPoint {
  width: 100% !important;
}
.breakPoint label {
  width: 50%;
}

.dateClass {
  font-size: 12px;
  text-align: center;
  height: 24px;
  color: #959cbd;
  border: none !important;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  background-image: url('calendar-icon.svg');
  background-repeat: no-repeat;
  background-position-x: 98%;
  background-position-y: center;
  background-color: #f2f4ff;
  cursor: pointer;
  border: none;
  outline: none;
  border-radius: 5px;
  padding-right: 25px;
  padding: 17px;
  border-bottom: 1px solid;
}

.dateLabel {
  margin-bottom: 5px;
}

::ng-deep .ng-select .ng-select-container {
  min-height: 20px !important;
  background: #f2f4ff;
  box-shadow: none;
}

::ng-deep .ng-value-container {
  margin: -10px 0px;
  margin-left: 5px;
}

.select {
  margin: 45px;
}
.select .selectClass {
  max-width: 300px;
}
.select .selectClass ::ng-deep .mat-mdc-select-placeholder {
  position: absolute;
  left: 12px;
  top: 13px;
}
.select ::ng-deep .mat-mdc-select-trigger {
  height: 50px;
}

.option {
  font-size: 12px !important;
  padding-left: 10px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
}
.option:active {
  color: #3e97ff !important;
}
.option:hover {
  color: #3e97ff;
}

.user-form {
  width: 100%;
}
.user-form ::ng-deep ngx-daterangepicker-material .md-drppicker {
  top: auto !important;
  position: fixed;
}

.selectClass {
  font-size: 12px !important;
  background-image: url('dropdown.svg');
  background-repeat: no-repeat;
  background-position-x: 94%;
  background-position-y: center;
  background-color: #f2f4ff;
  border-radius: 5px;
  max-width: 300px;
  text-align: center;
}
.selectClass mat-select ::ng-deep .mdc-list-item__primary-text {
  margin: 0px 40px !important;
}

.dateFilter {
  padding: 12px 0 !important;
  width: 210px;
}

.create-action {
  display: inline-block;
  margin-bottom: 0;
  line-height: 17px;
  text-align: left;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 300;
  height: 34px;
  min-width: 150px;
  background: #3e97ff;
  color: #ffffff;
  position: relative;
  text-align: center;
  border: none !important;
  position: relative;
  overflow: hidden;
  transition: background 0.5s;
  margin-bottom: 20px;
  margin-top: 12px;
}
.create-action:disabled {
  cursor: not-allowed;
}
.create-action:focus {
  outline: none;
}
.create-action:hover, .create-action:focus, .create-action:active {
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
  text-decoration: none;
}
.create-action span {
  color: #ffffff;
  position: relative;
  z-index: 9;
  padding-left: 2px;
}

.hoverEffect::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #1e2238, #1e2238);
  transition: left 0.5s;
}

.hoverEffect:hover::before {
  left: 0;
}

.button {
  text-align: center !important;
}

.headerFilter {
  display: grid;
  grid-template-columns: 8fr 1fr;
}

.iconClass {
  width: 35px !important;
  height: 35px !important;
  cursor: pointer;
}

.filters {
  min-width: 400px;
  max-width: 60vw;
  padding: 20px;
  text-align: center;
}
.filters .filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow-x: hidden;
  font-size: 18px;
}
.filters .filter-header div:nth-child(1),
.filters .filter-header div:nth-child(3) {
  width: 35px;
  height: 35px;
}
.filters .apply {
  padding: 0px !important;
  font-size: 16px !important;
}
.filters .report-generation-txt {
  color: #3f4254;
  font-weight: 500;
  font-size: 18px;
}
.filters .close {
  width: 30%;
}
.filters label {
  color: #181c32;
}
.filters .breakPoint {
  width: 100%;
}
.filters .form-group .breakPoint {
  width: 100% !important;
}
.filters .form-group label {
  margin-bottom: 5px;
}
.filters .form-group .selectClass {
  padding: 5px 0;
  margin: 7px 0;
}
.filters .form-group .selectClass ::ng-deep .mat-mdc-select-value {
  text-align: left;
  padding-left: 20px;
}
.filters .form-group {
  display: flex;
  margin-bottom: 20px;
  grid-template-columns: 1fr;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}
.filters .form-group label {
  width: 100%;
  text-align: left;
}
.filters .calendar-group label {
  margin-bottom: 0.7em;
}
.filters .calendar-group .form-control {
  padding: 0 5px;
  font-size: 12px !important;
  color: #535353;
}
.filters .calendar-group .form-control:focus, .filters .calendar-group .form-control:active {
  outline: none !important;
  box-shadow: none !important;
}
.filters .align-generate-btn {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
}
.filters .dashboardClass {
  margin: 0px -50px !important;
}
.filters .fmp-dashboard {
  position: relative;
  display: flex;
  justify-content: center;
}
.filters .fmp-dashboard .fmp-dashboard-text {
  color: #808080;
  font-size: 16px;
  font-weight: 600;
  padding-top: 10px;
}
.filters .fmp-dashboard .fmp-dashboard-date-range {
  font-size: 12px;
  color: #b3b3b3;
  margin-bottom: 10px;
}
.filters .fmp-dashboard .fmp-dashboard-date-range .main-div {
  display: flex;
  height: 35px;
  border: solid 2px #ebebeb;
  border-radius: 30px;
  height: 35px;
  width: max-content;
}
.filters .fmp-dashboard .fmp-dashboard-date-range .main-div .text:hover {
  color: #ef7f1a;
}
.filters .fmp-dashboard .fmp-dashboard-date-range .main-div .fmp-dashboard-date-range-text {
  padding: 10px 10px 0px 10px;
  border-right: solid 2px #ebebeb;
}
.filters .fmp-dashboard .fmp-dashboard-date-range .main-div .fmp-dashboard-date-range-second-text {
  padding: 10px 10px 0px 10px;
  border-right: solid 2px #ebebeb;
}
.filters .fmp-dashboard .fmp-dashboard-date-range .main-div .fmp-dashboard-date-range-third-text {
  padding: 10px 10px 0px 10px;
}
.filters .fmp-dashboard .fmp-dashboard-date-range .main-div .active {
  color: #ef7f1a;
}
.filters .fmp-dashboard .fmp-dashboard-date-picked {
  position: relative;
}
.filters .fmp-dashboard .fmp-dashboard-date-picked .fmp-dasboard-date-picker {
  width: 111%;
  padding: 8px 10px 0px 10px;
  height: 35px;
  border-radius: 30px;
  border: solid 2px #ebebeb;
  color: #b3b3b3;
  font-size: 12px;
}
.filters .fmp-dashboard .fmp-dashboard-date-picked img {
  width: 8%;
  margin-right: 10px;
}
.filters .fmp-dashboard .fmp-dashboard-content {
  position: absolute;
  right: 12vw;
  z-index: 1;
  top: 4vh;
}
.filters .fmp-dashboard .fmp-dashboard-content .content-bg {
  background-color: white;
  line-height: 2;
  width: 10vw;
  font-size: 14px;
  text-align: center;
  opacity: 0.9;
  color: #cccccc;
  border-radius: 5px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
}
.filters .fmp-dashboard .fmp-dashboard-content .content-bg .border-bottom-content {
  border-bottom: 1px solid #cccccc;
}
.filters .fmp-dashboard .text-right-aligned {
  text-align: -webkit-right;
  text-align: -moz-right;
  text-align: -o-right;
  text-align: -ms-right;
}
.filters .fmp-dashboard .arrow-left img {
  width: 28%;
}
.filters .fmp-dashboard .calendar-info {
  font-size: 11px;
  margin: 15px;
  padding: 10px;
  height: 23vh;
}
.filters .fmp-dashboard .active-tab {
  border-radius: 18px;
  background-color: #00a8e1;
  color: white;
  height: max-content;
}

@media (max-width: 568px) {
  .filters {
    min-width: 100%;
    max-width: 100%;
    width: 80vw;
  }
}
/* If screen size is more than 500px and less than 650px height, set table card height */
@media screen and (min-height: 619px) and (max-height: 800px) {
  .fmp-dashboard .calendar-info {
    font-size: 10px;
  }
}
@media screen and (min-height: 600px) and (max-height: 900px) {
  .fmp-dashboard .fmp-dashboard-content {
    right: 7vw !important;
  }
  .fmp-dashboard .fmp-dashboard-content .content-bg {
    width: 15vw !important;
  }
}
@media (max-width: 768px) {
  .firstCol {
    display: none;
  }
  .background {
    padding: 0 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/global.scss","webpack://./src/app/utils/components/download-filter-dialog/download-filter-dialog.component.scss"],"names":[],"mappings":"AAAA,iDAAA;AAEA;EACE,gBAAA;ACAF;;ADGA;EACE,qBAAA;ACAF;;ADGA;EACE,sBAAA;ACAF;;ADQA;EACE,sBAAA;ACLF;;ADQA;EACE,aAAA;ACLF;;ADQA;;;EAGE,oCAAA;EACA,gCAAA;ACLF;;ADQA;EACE,oCAAA;ACLF;;ADQA,cAAA;AAmDA,WAAA;AAEA,4BAAA;AAcA,gDAAA;AAuBA,2CAAA;AAaA,uBAAA;AAgBA;;EAAA;AAUA;;CAAA;AAcA,6BAAA;AAoEA,8BAAA;AASA,yBAAA;AAuBA,qBAAA;AAQA,mDAAA;AAaA,0BAAA;AAmBE;EACE,kBAAA;AC9QJ;ADsRM;EACE,yBAAA;EACA,yBAAA;EACA,2BAAA;ACpRR;ADwRI;EAtEF,yBAwE2B;EAvE3B,cAuEoC;EAtEpC,2BAsE6C;EArE7C,eAqEkE;EAnElE,gBAAA;EACA,yCAAA;AChNF;;ADuRA,mCAAA;AA8BA;EACE,wBAAA;ACjTF;;ADoTA;EACE,oCAAA;ACjTF;;ADoTA;EACE,8BAAA;ACjTF;;ADoTA;EACE,8BAAA;ACjTF;;ADoTA;EACE,oCAAA;ACjTF;;ADoTA;EACE,uBAAA;ACjTF;;ADqTE;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AClTJ;ADoTI;EAKE,yBAAA;EACA,aAAA;EACA,oBAAA;ACtTN;ADgTM;EACE,yBAAA;AC9SR;ADsTI;EACE,8BAAA;ACpTN;ADuTI;EACE,eAAA;ACrTN;ADwTI;EACE,0CAAA;EACA,4BAAA;ACtTN;ADwTM;EACE,iBAAA;EACA,sBAAA;ACtTR;ADyTM;EACE,wBAAA;ACvTR;;AD6TA;;EAEE,sBAAA;EACA,gBAAA;AC1TF;;AD6TA;EACE,mBAAA;EACA,kBAAA;AC1TF;;AD6TA;EACE,yDAAA;AC1TF;;AD6TA;EACE,aAAA;AC1TF;;AD8TE;EACE,qBAAA;AC3TJ;AD8TE;EACE,QAAA;AC5TJ;;ADiUA,kBAAA;AAEA;EACE,mBAAA;AC/TF;ADiUE;EACE,kBAAA;EACA,0BAAA;EACA,oBAAA;EACA,WAAA;AC/TJ;;ADmUA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,aAAA;AChUF;ADkUE;EACE,YAAA;AChUJ;ADmUE;EACE,0BAAA;ACjUJ;ADoUE;EACE,qBAAA;AClUJ;ADqUE;EACE,YAAA;ACnUJ;ADsUE;EACE,mBAAA;EACA,qBAAA;EACA,oBAAA;ACpUJ;ADuUE;EACE,yBAAA;EACA,aAAA;EACA,oBAAA;ACrUJ;ADuUI;EACE,yBAAA;ACrUN;ADyUI;EACE,qBAAA;ACvUN;AD0UI;EACE,uBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,cAAA;ACxUN;AD2UI;EACE,8BAAA;ACzUN;AD4UI;EACE,6BAAA;AC1UN;AD6UI;EACE,WAAA;AC3UN;AD+UE;EACE,eAAA;AC7UJ;ADiVI;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,0CAAA;EACA,4BAAA;EACA,2BAAA;AC/UN;ADkVI;EACE,wBAAA;AChVN;;ADqVA,kBAAA;AAGA;;EAEE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,qBAAA;ACpVF;;ADuVA;EACE,iCAAA;ACpVF;ADsVE;EACE,uCAAA;ACpVJ;;ADwVA;EACE,yCAAA;ACrVF;ADuVE;EACE,+CAAA;ACrVJ;;AAhQA;EACE,eAAA;AAmQF;;AAhQA;EACE,aAAA;EACA,uBAAA;AAmQF;AAjQE;EACE,WAAA;EACA,aAAA;AAmQJ;;AA/PA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AAkQF;AA/PE;EACE,0BAAA;AAiQJ;AA9PI;EACE,SAAA;AAgQN;AA7PI;EACE,WAAA;AA+PN;AA5PI;EACE,0BAAA;AA8PN;AAzPI;EACE,sBAAA;EACA,uBAAA;EACA,0BAAA;AA2PN;AAvPE;EACE,WAAA;AAyPJ;AAvPI;EACE,eAAA;AAyPN;;AAjOA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAoOF;;AAjOA;EACE,oBAAA;AAoOF;;AAjOA;EACE,YAAA;AAoOF;;AAhOE;EACE,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;AAmOJ;;AA1NA;EACE,sBAAA;AA6NF;;AA1NA;EAKE,sBAAA;AAyNF;AA7NE;EACE,UAAA;AA+NJ;;AAzNA;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,cDzDS;EC0DT,uBAAA;EACA,kCDvCa;ECwCb,gBDrCO;ECsCP,0CAAA;EACA,4BAAA;EAEA,0BAAA;EACA,6BAAA;EAEA,yBDvFc;ECwFd,eAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,wBAAA;AA0NF;;AAvNA;EACE,kBAAA;AA0NF;;AAvNA;EACE,2BAAA;EACA,mBDvGc;ECwGd,gBAAA;AA0NF;;AAvNA;EACE,iBAAA;EACA,gBAAA;AA0NF;;AAvNA;EACE,YAAA;AA0NF;AAxNE;EACE,gBAAA;AA0NJ;AAxNI;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AA0NN;AAtNE;EACE,YAAA;AAwNJ;;AApNA;EACE,0BAAA;EACA,kBAAA;EAEA,kCD9Fa;EC+Fb,gBD5FO;ACkTT;AApNE;EACE,yBAAA;AAsNJ;AAnNE;EACE,cDhJM;ACqWV;;AAjNA;EACE,WAAA;AAoNF;AAlNE;EACE,oBAAA;EACA,eAAA;AAoNJ;;AAhNA;EACE,0BAAA;EAEA,qCAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;EACA,yBDlKc;ECmKd,kBAAA;EAEA,gBAAA;EACA,kBAAA;AAiNF;AA9MI;EACE,2BAAA;AAgNN;;AA3MA;EACE,0BAAA;EACA,YAAA;AA8MF;;AA3MA;ED9BE,qBAAA;EAEA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EACA,6BAAA;EAzGA,kBCkIE;EDvBF,eCqBE;EDpBF,gBCqBE;EDpBF,YCkBE;EDjBF,gBCgBE;EDfF,mBA7KQ;EA8KR,cAzIM;EA0IN,kBAAA;EACA,kBAAA;ECyBA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;AAsNF;ADlPE;EACE,mBAAA;ACoPJ;ADjPE;EACE,aAAA;ACmPJ;ADhPE;EAME,yBAAA;EACA,uCAAA;EACA,qBAAA;AC6OJ;AA7OE;EACE,cD9JI;EC+JJ,kBAAA;EACA,UAAA;EACA,iBAAA;AA+OJ;;AAnOA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;EACA,qBAAA;AAsOF;;AAnOA;EACE,OAAA;AAsOF;;AAnOA;EACE,6BAAA;AAsOF;;AAnOA;EACE,aAAA;EACA,8BAAA;AAsOF;;AAnOA;EACE,sBAAA;EACA,uBAAA;EACA,eAAA;AAsOF;;AAnOA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AAsOF;AApOE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EASA,kBAAA;EACA,eAAA;AA8NJ;AAtOI;;EAEE,WAAA;EACA,YAAA;AAwON;AAhOE;EACE,uBAAA;EACA,0BAAA;AAkOJ;AA/NE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAiOJ;AA9NE;EACE,UAAA;AAgOJ;AA7NE;EACE,cDrQG;ACoeP;AA5NE;EACE,WAAA;AA8NJ;AA1NI;EACE,sBAAA;AA4NN;AAzNI;EACE,kBAAA;AA2NN;AAxNI;EACE,cAAA;EACA,aAAA;AA0NN;AAxNM;EACE,gBAAA;EACA,kBAAA;AA0NR;AArNE;EACE,aAAA;EAEA,mBAAA;EACA,0BAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;AAsNJ;AApNI;EACE,WAAA;EACA,gBAAA;AAsNN;AA9MI;EACE,oBAAA;AAgNN;AA7MI;EACE,cAAA;EACA,0BAAA;EACA,cAAA;AA+MN;AA7MM;EAEE,wBAAA;EACA,2BAAA;AA8MR;AAzME;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AA2MJ;AAvME;EACE,4BAAA;AAyMJ;AAtME;EACE,kBAAA;EACA,aAAA;EAEA,uBAAA;AAuMJ;AApMI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAsMN;AAnMI;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAqMN;AAnMM;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAqMR;AAnMQ;EACE,cAAA;AAqMV;AAlMQ;EACE,2BAAA;EACA,+BAAA;AAoMV;AAjMQ;EACE,2BAAA;EACA,+BAAA;AAmMV;AAhMQ;EACE,2BAAA;AAkMV;AA/LQ;EACE,cAAA;AAiMV;AA5LI;EACE,kBAAA;AA8LN;AA5LM;EACE,WAAA;EACA,0BAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;AA8LR;AA1LM;EACE,SAAA;EACA,kBAAA;AA4LR;AAxLI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;AA0LN;AAxLM;EACE,uBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,2CAAA;AA0LR;AAxLQ;EACE,gCAAA;AA0LV;AArLI;EACE,yBAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;AAuLN;AAnLM;EACE,UAAA;AAqLR;AAjLI;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;AAmLN;AAhLI;EACE,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;AAkLN;;AA7KA;EACE;IACE,eAAA;IACA,eAAA;IACA,WAAA;EAgLF;AACF;AA7KA,wFAAA;AACA;EAEI;IACE,eAAA;EA8KJ;AACF;AA1KA;EAEI;IACE,qBAAA;EA2KJ;EAzKI;IACE,sBAAA;EA2KN;AACF;AAtKA;EACE;IACE,aAAA;EAwKF;EArKA;IACE,eAAA;EAuKF;AACF","sourcesContent":["/* Global variables adn mixins are defined here */\n\n::ng-deep .cdk-global-scrollblock {\n  overflow: hidden;\n}\n\n::ng-deep mat-pseudo-checkbox {\n  width: 0px !important;\n}\n\n::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  width: auto !important;\n  // height: auto !important;\n}\n\n// ::ng-deep mat-option{\n//     display: flex !important;\n//     justify-content: center !important;\n// }\n::ng-deep .mdc-list-item__primary-text {\n  margin: 0px !important;\n}\n\n::ng-deep .mdc-tab__ripple {\n  display: none;\n}\n\n::ng-deep .mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background,\n.mdc-checkbox .mdc-checkbox__native-control:enabled:indeterminate~.mdc-checkbox__background,\n.mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=\"true\"]:enabled~.mdc-checkbox__background {\n  background-color: #3e97ff !important;\n  border-color: #3e97ff !important;\n}\n\n.toaster {\n  background-color: #f4f7ff !important;\n}\n\n/* variables */\n\n$primary: #3e97ff;\n$primary-active: #2884ef;\n$primary-light: #f2f4ff;\n$success: #50cd89;\n$success-active: #50cd89;\n$success-light: #e8fff3;\n$danger: #ff4b55;\n$danger-active: #d9214e;\n$danger-light: #fff5f8;\n$info: #7dcfdb;\n$info-active: #4fc9da;\n$info-light: #edf9fb;\n$warning: #ffa800;\n$warning-active: #ffa800;\n$warning-light: #fff7e7;\n$white: #ffffff;\n$white-active: #f5f8fa;\n$dark: #181c32;\n$gray-100: #f9f9f9;\n$gray-200: #f1f1f2;\n$gray-300: #e1e3ea;\n$gray-400: #d8d8e5;\n$gray-500: #959cbd;\n$gray-600: #7e8299;\n$gray-700: #5e6278;\n$gray-800: #3f4254;\n$gray-900: #181c32;\n$gray-button: #1e2238;\n\n//\n$primary-clr-dark: #232f3e;\n$primary-clr: #3e97ff;\n$primary-clr-alpha: #00a8e1;\n$bg-clr: #f3f3f3;\n$bg-clr-alpha: #edeced;\n$primary-ft-clr: #595a5c;\n$primary-grey: #707070;\n$white: #ffffff;\n$black: #3f4254;\n// $success: #347439;\n$failure: #ff0000;\n$grey: #cccccc;\n$primary-font: \"Poppins\", sans-serif;\n$ft-thin: 300;\n$ft-regular: 400;\n$ft-500: 500;\n$ft-bold: 700;\n$ft-semibold: 600;\n\n/* MIXINS */\n\n/* mixin for border radius */\n\n@mixin border-radius($top, $right, $bottom, $left) {\n  -webkit-border-radius: $top $right $bottom $left;\n  -moz-border-radius: $top $right $bottom $left;\n  border-radius: $top $right $bottom $left;\n}\n\n@mixin border-single-radius($rad) {\n  -webkit-border-radius: $rad;\n  -moz-border-radius: $rad;\n  border-radius: $rad;\n}\n\n/* To create a section at the center of window */\n@mixin create-centered-section($width,\n  $border-radius,\n  $padding-tb,\n  $padding-lr,\n  $border,\n  $background,\n  $left) {\n  position: absolute;\n  margin: auto;\n  top: 0;\n  left: $left;\n  right: 0;\n  bottom: 0;\n  width: $width;\n  height: 50vh;\n  // max-height: 520px;\n  border-radius: $border-radius;\n  padding: $padding-tb $padding-lr;\n  border: $border;\n  background: $background;\n}\n\n/* To include and adjust background image */\n@mixin set-background-image($bg-color,\n  $bg-url,\n  $bg-position,\n  $bg-repeat,\n  $bg-size) {\n  background: $bg-color;\n  background-image: $bg-url;\n  background-position: $bg-position;\n  background-repeat: $bg-repeat;\n  background-size: $bg-size;\n}\n\n/* to split the input */\n@mixin split-input($ltr-space,\n  $bg-img,\n  $bg-position,\n  $bg-size,\n  $bg-repeat,\n  $bg-pos-x) {\n  border: 0;\n  letter-spacing: $ltr-space;\n  background-image: $bg-img;\n  background-position: bottom;\n  background-size: $bg-size;\n  background-repeat: $bg-repeat;\n  background-position-x: $bg-pos-x;\n}\n\n/* box-shadow generator\n    $clr- in RGBA format\n */\n\n@mixin box-shadows($hset, $vset, $blur, $spread, $clr) {\n  -webkit-box-shadow: $hset $vset $blur $spread $clr;\n  -moz-box-shadow: $hset $vset $blur $spread $clr;\n  box-shadow: $hset $vset $blur $spread $clr;\n}\n\n/*\nremove the autofilled background color\n*/\n@mixin remove-autofill-background() {\n\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  input:-webkit-autofill:active {\n    transition-delay: 99999s;\n    -webkit-transition-delay: 99999s;\n  }\n}\n\n/* mixin for create buttons */\n\n@mixin create-buttons($bgClr,\n  $clr,\n  $ptb,\n  $plr,\n  $width,\n  $height,\n  $ft-size,\n  $ft-weight,\n  $rad) {\n  display: inline-block;\n  // padding: $ptb $plr;\n  margin-bottom: 0;\n  line-height: calc($height/2);\n  text-align: left;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  @include border-single-radius($rad);\n  font-size: $ft-size;\n  font-weight: $ft-weight;\n  height: $height;\n  min-width: $width;\n  background: $bgClr;\n  color: $clr;\n  position: relative;\n  text-align: center;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &:hover,\n  &:focus,\n  &:active {\n    // background: $clr;\n    // color: $bgClr;\n    // border: 1px solid $bgClr;\n    transition-duration: 0.5s;\n    transition-timing-function: ease-in-out;\n    text-decoration: none;\n  }\n}\n\n@mixin no-transition($bg-color, $color) {\n\n  &:hover,\n  &:focus,\n  &:active {\n    background: $bg-color;\n    color: $color;\n    border: 1px solid $bg-color;\n  }\n}\n\n/* generate margin & padding */\n@mixin generate-margin($tp, $rt, $bt, $lt) {\n  margin: $tp $rt $bt $lt;\n}\n\n@mixin generate-padding($tp, $rt, $bt, $lt) {\n  padding: $tp $rt $bt $lt;\n}\n\n/* to set the table row */\n@mixin set-table-row($bg-color,\n  $color,\n  $border,\n  $font-size,\n  $font-weight,\n  $fontFamily: \"\"\n\n) {\n  background-color: $bg-color;\n  color: $color;\n  border: $border;\n  font-size: $font-size;\n  // font-weight: $font-weight;\n  font-weight: 500;\n  font-family: \"Amazon Ember Display Light\";\n\n  @if $fontFamily !=\"\" {\n    font-family: $fontFamily;\n    font-weight: $font-weight;\n  }\n}\n\n/* to set the image */\n@mixin set-image-config($width, $height, $cursor, $margin-right) {\n  width: $width;\n  height: $height;\n  cursor: $cursor;\n  margin-right: $margin-right;\n}\n\n/* to set the styles for first and last child div */\n@mixin set-child-div($color1, $font-size1, $font-weight1, $color2) {\n  div:first-child {\n    color: $color1;\n    font-size: $font-size1;\n    font-weight: $font-weight1;\n  }\n\n  div:last-child {\n    color: $color2;\n  }\n}\n\n/* to set the font style */\n@mixin set-font-config($fontSize,\n  $fontWeight,\n  $fontColor,\n  $textAlign,\n  $fontFamily: \"\"\n\n) {\n  font-size: $fontSize;\n  font-weight: $fontWeight;\n  color: $fontColor;\n  text-align: $textAlign;\n\n  @if $fontFamily !=\"\" {\n    font-family: $fontFamily;\n  }\n}\n\n.ast-table {\n  .table {\n    margin-bottom: 0px;\n  }\n\n  table {\n    thead {\n\n      // @mixin set-table-row($bg-color, $color, $border, $font-size, $font-weight)\n      // @include set-table-row($white, #231f20, 0.5px solid #e2e2e1, 16px, 300) ;\n      th {\n        background-color: #edeced;\n        border: 1px solid #dee2e6;\n        border-top: none !important;\n      }\n    }\n\n    td {\n      // @mixin set-table-row($bg-color, $color, $border, $font-size, $font-weight)\n      @include set-table-row(#fafafa, #231f20, 0.5px solid #e2e2e1, 16px, 300);\n    }\n  }\n}\n\n/* To create a card at the center */\n@mixin create-card($width,\n  $height,\n  $border-radius,\n  $padding-tb,\n  $padding-lr,\n  $border,\n  $background,\n  $left) {\n  position: relative;\n  margin: auto;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: $width;\n  height: $height;\n  border-radius: $border-radius;\n  padding: $padding-tb $padding-lr;\n  border: $border;\n  background: $background;\n  text-align: center;\n}\n\n@mixin flexbox($display, $align-items, $justify-content) {\n  display: $display;\n  align-items: $align-items;\n  justify-content: $justify-content;\n}\n\n::ng-deep mat-pseudo-checkbox {\n  display: none !important;\n}\n\n::ng-deep .mat-calendar-body-selected {\n  background-color: $primary !important;\n}\n\n::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::after {\n  border-bottom: none !important;\n}\n\n::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) .mdc-line-ripple::before {\n  border-bottom: none !important;\n}\n\n::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {\n  background-color: $primary-light !important;\n}\n\n::ng-deep .mat-form-field {\n  border: none !important;\n}\n\n.dateselect {\n  mat-form-field {\n    display: flex;\n    height: 25px;\n    width: 185px;\n    font-size: 12px;\n    text-align: center;\n    height: 24px;\n    font-family: \"Poppins\", sans-serif;\n    font-weight: 500;\n    margin-top: 7px;\n    margin-left: 8px;\n\n    mat-date-range-input {\n      ::ng-deep .mat-date-range-input-separator {\n        color: #959cbd !important;\n      }\n\n      color: #959cbd !important;\n      display: flex;\n      justify-self: center;\n    }\n\n    ::ng-deep .mat-date-range-input-content {\n      border-bottom: none !important;\n    }\n\n    mat-label {\n      font-size: 12px;\n    }\n\n    ::ng-deep mat-datepicker-toggle {\n      background-image: url(../images/calendar-icon.svg);\n      background-repeat: no-repeat;\n\n      button {\n        margin-left: 35px;\n        width: 20px !important;\n      }\n\n      .mat-mdc-icon-button svg {\n        display: none !important;\n      }\n    }\n  }\n}\n\n::ng-deep .mat-mdc-form-field-icon-suffix,\n[dir=\"rtl\"] .mat-mdc-form-field-icon-prefix {\n  width: 30px !important;\n  margin-top: 10px;\n}\n\n::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {\n  align-items: center;\n  border-radius: 5px;\n}\n\n::ng-deep .mat-mdc-icon-button {\n  --mat-icon-button-hover-state-layer-opacity: 0 !important;\n}\n\n::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {\n  display: none;\n}\n\n.tab-header {\n  ::ng-deep .mat-mdc-tab-list {\n    align-content: center;\n  }\n\n  ::ng-deep .mat-mdc-tab-links {\n    gap: 5px;\n  }\n}\n\n\n/** Date Picker **/\n\n::ng-deep mat-datepicker-toggle {\n  width: 0 !important;\n\n  button {\n    position: absolute;\n    /* margin-bottom: -20px; */\n    top: -23% !important;\n    right: 40px;\n  }\n}\n\n.date-picker {\n  height: 25px;\n  min-width: 180px;\n  font-size: 12px;\n  text-align: center;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 500;\n  margin: 7px 0;\n\n  mat-form-field {\n    width: 210px;\n  }\n\n  ::ng-deep .mdc-text-field {\n    padding-left: 0 !important;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {\n    padding: 0 !important;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex {\n    height: 23px;\n  }\n\n  ::ng-deep .mdc-text-field .mat-mdc-form-field-flex .mat-mdc-form-field-icon-suffix {\n    width: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n\n  mat-date-range-input {\n    color: #959cbd !important;\n    display: flex;\n    justify-self: center;\n\n    ::ng-deep .mat-date-range-input-separator {\n      color: #959cbd !important;\n      // margin: 0 10px;\n    }\n\n    ::ng-deep .mat-date-range-input-inner {\n      letter-spacing: 0.5px;\n    }\n\n    ::ng-deep .mat-date-range-input-container {\n      justify-content: center;\n      font-family: \"Poppins\";\n      width: fit-content;\n      margin: 0 10px;\n    }\n\n    ::ng-deep .mat-date-range-input-content {\n      border-bottom: none !important;\n    }\n\n    ::ng-deep .mat-date-range-input-end-wrapper {\n      flex-grow: initial !important;\n    }\n\n    ::ng-deep .mat-date-range-input-wrapper {\n      width: 70px;\n    }\n  }\n\n  mat-label {\n    font-size: 12px;\n  }\n\n  ::ng-deep mat-datepicker-toggle {\n    button {\n      width: 24px !important;\n      height: 24px !important;\n      padding: 0 !important;\n      transform: translateX(10px);\n      background-image: url(../images/calendar-icon.svg);\n      background-repeat: no-repeat;\n      background-position: center;\n    }\n\n    .mat-mdc-icon-button svg {\n      display: none !important;\n    }\n  }\n}\n\n/** Date Picker **/\n\n\n.back-button,\n.close-button {\n  width: 35px;\n  height: 35px;\n  background-position: center;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  transition: all .25s;\n}\n\n.back-button {\n  background-image: url('../images/back.svg');\n\n  &:hover {\n    background-image: url('../images/back-hover.svg');\n  }\n}\n\n.close-button {\n  background-image: url('../images/close-circle.svg');\n\n  &:hover {\n    background-image: url('../images/close-cirlce-hover.svg');\n  }\n}","@import \"../../../../assets/styles/global.scss\";\n\n* {\n  font-size: 14px;\n}\n\n.firstCol {\n  display: flex;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    padding: 25px;\n  }\n}\n\n.date-picker {\n  width: 100%;\n  height: 34px;\n  max-width: 300px;\n\n\n  mat-date-range-input {\n    font-size: 12px !important;\n    // justify-content: center;\n\n    ::ng-deep .mat-date-range-input-separator {\n      margin: 0;\n    }\n\n    ::ng-deep .mat-date-range-input-wrapper {\n      width: 90px;\n    }\n\n    ::ng-deep .mat-date-range-input-inner {\n      font-size: 12px !important;\n    }\n  }\n\n  ::ng-deep mat-datepicker-toggle {\n    button {\n      width: 30px !important;\n      height: 30px !important;\n      transform: translateX(5px);\n    }\n  }\n\n  mat-form-field {\n    width: 100%;\n\n    mat-label {\n      font-size: 12px;\n    }\n  }\n}\n\n// ::ng-deep .mat-mdc-form-field-icon-suffix,\n// [dir=\"rtl\"] .mat-mdc-form-field-icon-prefix {\n//   width: 30px !important;\n//   margin-top: 10px;\n// }\n\n// ::ng-deep .mat-mdc-form-field-has-icon-suffix .mat-mdc-text-field-wrapper {\n//   align-items: center;\n//   border-radius: 5px;\n// }\n\n// ::ng-deep .mat-mdc-icon-button {\n//   --mat-icon-button-hover-state-layer-opacity: 0 !important;\n// }\n\n// ::ng-deep .mat-mdc-icon-button .mat-mdc-button-persistent-ripple {\n//   display: none;\n// }\n\n.secondCol {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.background {\n  padding: 15px 20px 0;\n}\n\n::ng-deep .mat-mdc-dialog-container .mdc-dialog__container {\n  height: auto;\n}\n\n::ng-deep .downloadFilter-dialog {\n  ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n    overflow: auto;\n    overflow-x: hidden;\n    width: 100% !important;\n    height: auto !important;\n  }\n}\n\n// ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface{\n//   overflow:  auto;\n//   overflow-x: hidden;\n//   height: 220px !important;\n// }\nmat-select .breakPoint {\n  width: 100% !important;\n}\n\n.breakPoint {\n  label {\n    width: 50%;\n  }\n\n  width: 100% !important;\n}\n\n.dateClass {\n  font-size: 12px;\n  text-align: center;\n  height: 24px;\n  color: $gray-500;\n  border: none !important;\n  font-family: $primary-font;\n  font-weight: $ft-500;\n  background-image: url(\"../../../../assets/images/calendar-icon.svg\");\n  background-repeat: no-repeat;\n  // background-position: 155px;\n  background-position-x: 98%;\n  background-position-y: center;\n  // background-position: right;\n  background-color: $primary-light;\n  cursor: pointer;\n  border: none;\n  outline: none;\n  border-radius: 5px;\n  padding-right: 25px;\n  padding: 17px;\n  border-bottom: 1px solid;\n}\n\n.dateLabel {\n  margin-bottom: 5px;\n}\n\n::ng-deep .ng-select .ng-select-container {\n  min-height: 20px !important;\n  background: $primary-light;\n  box-shadow: none;\n}\n\n::ng-deep .ng-value-container {\n  margin: -10px 0px;\n  margin-left: 5px;\n}\n\n.select {\n  margin: 45px;\n\n  .selectClass {\n    max-width: 300px;\n\n    ::ng-deep .mat-mdc-select-placeholder {\n      position: absolute;\n      left: 12px;\n      top: 13px;\n    }\n  }\n\n  ::ng-deep .mat-mdc-select-trigger {\n    height: 50px;\n  }\n}\n\n.option {\n  font-size: 12px !important;\n  padding-left: 10px;\n  // text-align: center;\n  font-family: $primary-font;\n  font-weight: $ft-500;\n\n  &:active {\n    color: $primary !important;\n  }\n\n  &:hover {\n    color: $primary;\n  }\n}\n\n.user-form {\n  width: 100%;\n\n  ::ng-deep ngx-daterangepicker-material .md-drppicker {\n    top: auto !important;\n    position: fixed;\n  }\n}\n\n.selectClass {\n  font-size: 12px !important;\n  // margin: 7px 0px;\n  background-image: url(\"../../../../assets/images/dropdown.svg\");\n  background-repeat: no-repeat;\n  background-position-x: 94%;\n  background-position-y: center;\n  background-color: $primary-light;\n  border-radius: 5px;\n  // padding: 5px !important;\n  max-width: 300px;\n  text-align: center;\n\n  mat-select {\n    ::ng-deep .mdc-list-item__primary-text {\n      margin: 0px 40px !important;\n    }\n  }\n}\n\n.dateFilter {\n  padding: 12px 0 !important;\n  width: 210px;\n}\n\n.create-action {\n  // @mixin create-buttons($bgClr,$clr,$ptb,$plr,$width,$height,$ft-size,$ft-weight,$rad)\n  @include create-buttons($primary,\n    $white,\n    0px,\n    0px,\n    150px,\n    34px,\n    16px,\n    300,\n    5px);\n\n  span {\n    color: $white;\n    position: relative;\n    z-index: 9;\n    padding-left: 2px;\n  }\n\n  border: none !important;\n  position: relative;\n  overflow: hidden;\n  transition: background 0.5s;\n  margin-bottom: 20px;\n  margin-top: 12px;\n  // width: 90%;\n}\n\n.hoverEffect::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to right, $gray-button, $gray-button);\n  transition: left 0.5s;\n}\n\n.hoverEffect:hover::before {\n  left: 0;\n}\n\n.button {\n  text-align: center !important;\n}\n\n.headerFilter {\n  display: grid;\n  grid-template-columns: 8fr 1fr;\n}\n\n.iconClass {\n  width: 35px !important;\n  height: 35px !important;\n  cursor: pointer;\n}\n\n.filters {\n  min-width: 400px;\n  max-width: 60vw;\n  padding: 20px;\n  text-align: center;\n\n  .filter-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    div:nth-child(1),\n    div:nth-child(3) {\n      width: 35px;\n      height: 35px;\n    }\n\n    // margin: 20px;\n    overflow-x: hidden;\n    font-size: 18px;\n  }\n\n  .apply {\n    padding: 0px !important;\n    font-size: 16px !important;\n  }\n\n  .report-generation-txt {\n    color: #3f4254;\n    font-weight: 500;\n    font-size: 18px;\n  }\n\n  .close {\n    width: 30%;\n  }\n\n  label {\n    color: $dark;\n  }\n\n  .breakPoint {\n    width: 100%;\n  }\n\n  .form-group {\n    .breakPoint {\n      width: 100% !important;\n    }\n\n    label {\n      margin-bottom: 5px;\n    }\n\n    .selectClass {\n      padding: 5px 0;\n      margin: 7px 0;\n\n      ::ng-deep .mat-mdc-select-value {\n        text-align: left;\n        padding-left: 20px;\n      }\n    }\n  }\n\n  .form-group {\n    display: flex;\n    // width: 100%;\n    margin-bottom: 20px;\n    grid-template-columns: 1fr;\n    justify-content: flex-start;\n    align-items: center;\n    flex-direction: column;\n\n    label {\n      width: 100%;\n      text-align: left;\n    }\n\n    // display: grid;\n    // justify-content: center;\n  }\n\n  .calendar-group {\n    label {\n      margin-bottom: 0.7em;\n    }\n\n    .form-control {\n      padding: 0 5px;\n      font-size: 12px !important;\n      color: #535353;\n\n      &:focus,\n      &:active {\n        outline: none !important;\n        box-shadow: none !important;\n      }\n    }\n  }\n\n  .align-generate-btn {\n    position: relative;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    // margin: 20px 0px;\n  }\n\n  .dashboardClass {\n    margin: 0px -50px !important;\n  }\n\n  .fmp-dashboard {\n    position: relative;\n    display: flex;\n    // display: grid !important;\n    justify-content: center;\n\n    // grid-template-columns: 1fr;\n    .fmp-dashboard-text {\n      color: #808080;\n      font-size: 16px;\n      font-weight: 600;\n      padding-top: 10px;\n    }\n\n    .fmp-dashboard-date-range {\n      font-size: 12px;\n      color: #b3b3b3;\n      margin-bottom: 10px;\n\n      .main-div {\n        display: flex;\n        height: 35px;\n        border: solid 2px #ebebeb;\n        border-radius: 30px;\n        height: 35px;\n        width: max-content;\n\n        .text:hover {\n          color: #ef7f1a;\n        }\n\n        .fmp-dashboard-date-range-text {\n          padding: 10px 10px 0px 10px;\n          border-right: solid 2px #ebebeb;\n        }\n\n        .fmp-dashboard-date-range-second-text {\n          padding: 10px 10px 0px 10px;\n          border-right: solid 2px #ebebeb;\n        }\n\n        .fmp-dashboard-date-range-third-text {\n          padding: 10px 10px 0px 10px;\n        }\n\n        .active {\n          color: #ef7f1a;\n        }\n      }\n    }\n\n    .fmp-dashboard-date-picked {\n      position: relative;\n\n      .fmp-dasboard-date-picker {\n        width: 111%;\n        padding: 8px 10px 0px 10px;\n        height: 35px;\n        border-radius: 30px;\n        border: solid 2px #ebebeb;\n        color: #b3b3b3;\n        font-size: 12px;\n        // width: max-content;\n      }\n\n      img {\n        width: 8%;\n        margin-right: 10px;\n      }\n    }\n\n    .fmp-dashboard-content {\n      position: absolute;\n      right: 12vw;\n      z-index: 1;\n      top: 4vh;\n\n      .content-bg {\n        background-color: white;\n        line-height: 2;\n        width: calc(100vw - (90vw));\n        font-size: 14px;\n        text-align: center;\n        opacity: 0.9;\n        color: #cccccc;\n        border-radius: 5px;\n        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);\n\n        .border-bottom-content {\n          border-bottom: 1px solid #cccccc;\n        }\n      }\n    }\n\n    .text-right-aligned {\n      text-align: -webkit-right;\n      text-align: -moz-right;\n      text-align: -o-right;\n      text-align: -ms-right;\n    }\n\n    .arrow-left {\n      img {\n        width: 28%;\n      }\n    }\n\n    .calendar-info {\n      font-size: 11px;\n      margin: 15px;\n      padding: 10px;\n      height: calc(100vh - (77vh));\n    }\n\n    .active-tab {\n      border-radius: 18px;\n      background-color: #00a8e1;\n      color: white;\n      height: max-content;\n    }\n  }\n}\n\n@media (max-width: 568px) {\n  .filters {\n    min-width: 100%;\n    max-width: 100%;\n    width: 80vw;\n  }\n}\n\n/* If screen size is more than 500px and less than 650px height, set table card height */\n@media screen and (min-height: 619px) and (max-height: 800px) {\n  .fmp-dashboard {\n    .calendar-info {\n      font-size: 10px;\n    }\n  }\n}\n\n@media screen and (min-height: 600px) and (max-height: 900px) {\n  .fmp-dashboard {\n    .fmp-dashboard-content {\n      right: 7vw !important;\n\n      .content-bg {\n        width: calc(100vw - (85vw)) !important;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .firstCol {\n    display: none;\n  }\n\n  .background {\n    padding: 0 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
